<template>
  <vs-row>
    <vs-col
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-md="12"
      vs-sm="12"
    >
      <vs-row vs-type="flex" vs-justify="center" class="mb-4">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <h1 class="">{{ locationName }}</h1>
        </vs-col>
      </vs-row>
      <vs-divider color="#197CBF"></vs-divider>
      <vs-row vs-justify="center">
        <vs-col vs-type="flex" vs-justify="left">
          <h5 class="">Selecciona una de las membresías disponibles</h5>
        </vs-col>
      </vs-row>
      <!-- tab 1 content -->
      <div class="vx-row">
        <!-- First Name -->
        <div class="vx-col w-full mt-5">
          <ul>
            <li
              class="mt-2 radio-btn-package"
              :class="{
                'radio-btn-package-active': locationPackage.active,
                'rounded-t': index == 0,
                'rounded-b': index == locationPackages.length - 1,
              }"
              v-for="(locationPackage, index) in locationPackages"
              :key="locationPackage._id"
              @click="selectPackage(locationPackage)"
            >
              <vs-row vs-type="flex" vs-justify="space-between">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-w="8">
                  <h6 class="text-base font-weight-medium">
                    {{ locationPackage.nombre }} -
                    {{ locationPackage.periodicity == 1 ? "MENSUAL" : "ANUAL" }}
                  </h6>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-w="2">
                  <h6 class="text-base font-weight-bold">
                    {{ moneyFormat(locationPackage.total) }}
                  </h6>
                </vs-col>
              </vs-row>
              <span class="text-md">
                Pago Proporcional Mes:
                {{ moneyFormat(locationPackage.packagePriceCurrentMonth) }} +
                Inscripción (Pago Único):
                <span
                  style="text-decoration: line-through !important"
                  v-if="!locationPackage.cobro_inscripcion"
                >
                  {{ moneyFormat(locationPackage.inscripcion) }}
                </span>
                <span style="text-decoration: none !important" v-else>
                  {{ moneyFormat(locationPackage.inscripcion) }}
                </span>
              </span>
              <br />
              <span class="text-md">
                Cuota
                {{ locationPackage.periodicity == 1 ? "Mensual" : "Anual" }} :
                {{ moneyFormat(locationPackage.precio) }}
              </span>

              <!--              <h6 class="radio-btn-package-title">
                {{ locationPackage.nombre }} - {{ locationPackage.periodo.toUpperCase() }}
              </h6>
              <span class="radio-btn-package-text"
                >Importe periodo: {{ moneyFormat(locationPackage.precio) }} +
                Inscripcion:
                <div
                  :class="{
                    'underline-text': !locationPackage.cobro_inscripcion,
                  }"
                >
                  {{ moneyFormat(locationPackage.inscripcion) }}
                </div></span
              >-->
            </li>
          </ul>
        </div>

        <div
          class="vx-col w-full mt-5 text-center"
          v-if="$v.selectLocationPackage.$error"
        >
          <span class="text-danger text-sm">{{ requiredErrorMessage }}</span>
        </div>
        <div class="vx-col w-full mt-5 text-left text-sm">
          <!-- <vs-alert color="primary" title="Consideraciónes" active="true"> -->
          <ul class="text-sm">
            <li>
              <b>Pago Proporcional Mes:</b> Se cobrará el pago proporcional de
              lo que resta del mes.
            </li>
            <li>
              <b>Inscripción (Pago Único):</b> Pago que se realizara únicamente
              una vez.
            </li>
            <li>
              <b>Cuota Mensual:</b> Pago que se debitará de la tarjeta
              mensualmente.
            </li>
          </ul>
          <!-- </vs-alert> -->
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import messageError from "@/constants/messageError.constants";
import moment from "moment-timezone";
import utils from "@/views/forms/form-wizard/form-wizard-register/utils";

export default {
  props: ["locationName", "locationPackages"],
  name: "second-step",
  data() {
    return {
      selectLocationPackage: {},
      model: {
        paquete_details: {
          paquete_id: "",
          fecha_inicio: "",
          total: "",
          periodicity: "",
        },
      },
      requiredErrorMessage: messageError.REQUIRED_MEMBERSHIP,
    };
  },
  validations() {
    return {
      selectLocationPackage: {
        required,
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (!this.$v.$error) {
        console.log({ selectLocationPackage: this.selectLocationPackage });
        this.model.paquete_details.paquete_id = this.selectLocationPackage._id;
        this.model.paquete_details.fecha_inicio = moment()
          .tz("America/Guatemala")
          .format("YYYY-MM-DD");
        this.model.paquete_details.total = +this.selectLocationPackage.total;
        //periodicity = 1 mensual, periodicity = 2 anual
        this.model.paquete_details.periodicity =
          this.selectLocationPackage.periodicity;
        this.$emit("on-validated", this.model);
        utils.nextStep();
        return true;
      } else {
        this.$vs.loading.close();
        this.$vs.loading.close("#vx-loading > .con-vs-loading");
        utils.nextStep();
        return false;
      }
    },
    moneyFormat(amount) {
      const amountNumber = Number(amount);
      const formattedAmount = amountNumber.toLocaleString("es-GT", {
        style: "currency",
        currency: "GTQ",
      });
      return formattedAmount;
    },
    selectPackage(selectedLocationPackage) {
      this.selectLocationPackage = selectedLocationPackage;
    },
  },
  watch: {
    selectLocationPackage() {
      if (this.selectLocationPackage) {
        this.locationPackages.forEach((locationPackage) => {
          if (locationPackage._id == this.selectLocationPackage._id) {
            locationPackage.active = true;
          } else {
            locationPackage.active = false;
          }
        });
      }
    },
    locationPackages() {
      this.selectLocationPackage = "";
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.underline-text {
  text-decoration: line-through;
}
.radio-btn-package {
  padding: 1rem;
  border: 1px solid;
  border-color: #e9e9eb;
  margin-top: 0px !important;
}

.radio-btn-package-active {
  border-color: #197cbf;
}

.radio-btn-package-title {
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 10px;
}

.radio-btn-package-text {
  padding-left: 10px;
  display: flex;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.font-weight-bold {
  font-size: 1rem !important;
  line-height: 1.5rem;
}
</style>
